import { CircularProgress, Box } from '@mui/material';

/**
 * Loading fallback para Suspense - mostrado durante carregamento lazy
 */
function LoadingFallback() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                bgcolor: 'background.default',
            }}
        >
            <CircularProgress />
        </Box>
    );
}

export default LoadingFallback;
